import {SET_PROFILES} from "../actions/profile";

const initialState = {
    profiles: []
};

export default (state=initialState, action) => {
    switch(action.type) {
        case SET_PROFILES:
            return Object.assign({}, state, {
                profiles: action.payload
            });

        default:
            return state;
    }
}